import { useQuery } from "@tanstack/react-query";
import { GET_DELIVERY_ADDRESSES_FOR_SHIPMENT } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IAddressesList } from "@/types/apiResponse.types";

export const useGetDeliveryAddressesForShipmentRequest = () => {
  return useQuery<{ data: { data: IAddressesList[] } }>({
    queryKey: [GET_DELIVERY_ADDRESSES_FOR_SHIPMENT],
    queryFn: () => apiRequest(GET_DELIVERY_ADDRESSES_FOR_SHIPMENT, "get"),
  });
};
